export const seasons = [
    "Spring", "Summer", "Autumn", "Winter"
];